import $ from "jquery";
import { Modal } from "bootstrap";

const mediaCenterObject = {
  variables: {
    $select: $("select"),
    $option: $("#year_list").find("option"),
    $container: $(".tab__pane--content"),
    $category: $(".tab__pane--content").attr("data-category"),
    $title: $("data[title]"),
    $date: $("data[date]"),
    url: window.location.href,
    $loadMoreTrigger: false,
  },
  methods: {
    sortYear: function () {
      mediaCenterObject.variables.$option.sort(function (
        valueFirst,
        valueNext
      ) {
        return $(valueNext).val() - $(valueFirst).val();
      });

      $('media-center--dropdown').find(mediaCenterObject.variables.$select)
        .empty()
        .append(mediaCenterObject.variables.$option);
    },

    showVisiblePdfNews: function (filteredItem) {
      let itemsPerPage = $(window).width() < 768 ? 6 : 4;

      if (filteredItem.length === 0) {
        $(".news__text").find(".msg_text").show();
        $("#load_more_btn--news").hide();
      } else {
        $(".news__text").find(".msg_text").hide();

        filteredItem.length <= 4 ||
        (filteredItem.length <= 6 && $(window).width() < 768)
          ? $("#load_more_btn--news").hide()
          : $("#load_more_btn--news").show();

        $(filteredItem).hide().slice(0, itemsPerPage).show();
        mediaCenterObject.methods.loadMoreNews(filteredItem);
      }
    },
    showVisiblePdfPR: function (filteredItem) {
      let itemsPerPage = $(window).width() < 768 ? 6 : 4;

      if (filteredItem.length === 0) {
        $(".pr__text").find(".msg_text").show();
        $("#load_more_btn--pr").hide();
      } else {
        $(".pr__text").find(".msg_text").hide();

        filteredItem.length <= 4 ||
        (filteredItem.length <= 6 && $(window).width() < 768)
          ? $("#load_more_btn--pr").hide()
          : $("#load_more_btn--pr").show();

        $(filteredItem).hide().slice(0, itemsPerPage).show();
        mediaCenterObject.methods.loadMorePR(filteredItem);
      }
    },

    loadMoreNews: function (items) {
      let limit = 2;
      $("#load_more_btn--news")
        .off("click")
        .on("click", function () {
          let hiddenCards = $(items).filter(":hidden");
          const $self = $(this);
          $self.prop('disabled',true);
          if (hiddenCards.length > 0) {
            const remainingHiddenCards = hiddenCards.slice(0, limit)
            remainingHiddenCards.fadeIn(1000,function(){
              const targetElement = hiddenCards.slice(0,limit).last();
              if(targetElement.length){
                const containerOffset = $('.tab__pane--inner').offset().top;
                const targetOffset = targetElement.offset().top;
                const scrollToPosition = targetOffset - containerOffset + $('.tab__pane--inner').scrollTop();
              $('.tab__pane--inner').animate({
                scrollTop:scrollToPosition
              },500);
              $self.prop("disabled",false);
            }
            });
            if (hiddenCards.length <= 2) {
              $self.addClass('d-none');
            }
          }
        });
    },
    loadMorePR: function (items) {
      let limit = 2;
      $("#load_more_btn--pr")
        .off("click")
        .on("click", function () {
          let hiddenCards = $(items).filter(":hidden");
          const $self = $(this);
          $self.prop("disabled",true);
          if (hiddenCards.length > 0) {
            hiddenCards.slice(0, limit).fadeIn(1000,function(){
              const targetElement  = hiddenCards.slice(0,limit).last();
              if(targetElement.length){
                const containerOffset = $('.tab__pane--inner').offset().top;
                const targetOffset = targetElement.offset().top;
                const scrollToPosition = targetOffset - containerOffset + $('.tab__pane--inner').scrollTop();
              $('.tab__pane--inner').animate({
                scrollTop:scrollToPosition
              },500);
              $self.prop("disabled",false);
            }
            });
            if (hiddenCards.length <= 2) {
              $self.addClass('d-none');
            }
          }
        });
    },

    buttonClickHandler: function(){
      $('.media_center_blogs.media').on('click', '.media_tabs__item--title', function() {
           let buttonName = $(this).text().trim();
           let titleText = $(this).closest('.media_center__wrapper').find('.media_center__wrapper--title h2').text().trim();
           let obj = mediaCenterObject.methods.dataLayerObj(titleText,buttonName,null);
           createDataLayer('buttonClick',obj);
      });
    },

    showBlogsAtInitial: function () {
      let itemsPerPage = $(window).width() < 768 ? 6 : 4;

      $(".tab__pane--contentNews").hide().slice(0, itemsPerPage).show();
      $(".tab__pane--contentPR").hide().slice(0, itemsPerPage).show();

      this.loadMoreNews($(".tab__pane--contentNews"));

      this.loadMorePR($(".tab__pane--contentPR"));
    },

    searchPdf: function () {
      let filteredItemNews = [];
      let filteredItemPR = [];

      let searchTerm = $(".media_center--input").val().toLowerCase();
      let selectedYear =
        $(window).width() < 768
          ? $(".year-dropdown--mob").val()
          : $(".year-dropdown").val();

      $("#load_more_btn--news,#load_more_btn--pr").show();

      $(".tab__pane--content").each(function () {
        let title = $(this).find(".title").data("title")
          ? $(this).find(".title").data("title").toLowerCase()
          : "";
        let year = $(this).find(".date").data("year");

        if (
          (selectedYear === "All Years" && title.includes(searchTerm)) ||
          (selectedYear == year && title.includes(searchTerm)) ||
          (selectedYear == year && searchTerm === "")
        ) {
          $(this).show();
          if ($(this).data("category") == "News") {
            filteredItemNews.push(this);
            $(this).attr("data-year", year);
          } else if ($(this).data("category") == "Press Release") {
            filteredItemPR.push(this);
            $(this).attr("data-year", year);
          }
        } else {
          $(this).hide();
        }
      });
      if (filteredItemNews.length === 0) {
        $(".msg_text").show();
      }
      if (filteredItemPR.length === 0) {
        $(".msg_text").show();
      }
      mediaCenterObject.methods.showVisiblePdfNews(filteredItemNews);
      mediaCenterObject.methods.showVisiblePdfPR(filteredItemPR);
    },

    searchOnInput: function () {
      $(".media_center--input").on("input", function () {
        mediaCenterObject.methods.searchPdf();
      });
    },

    searchByYear: function () {
      $(".year-dropdown").on("change", function () {
        mediaCenterObject.methods.searchPdf();
      });
      $(".year-dropdown--mob").on("change", function () {
        var myModal = Modal.getInstance(
          $("#filterModal").get(0)
        );
        if (myModal) {
          myModal.hide();
        }
        mediaCenterObject.methods.searchPdf();
      });
    },

    formSubmit: function () {
      $("#media_center_form").on("submit", function (e) {
        e.preventDefault();
      });
    },

    dataLayerObj: function (el, e, articleName) {
      var obj = {
        articleName: articleName ? articleName: "",
        blogCategory: "",
        blogPageCategory: "",
        buttonText: e ? e : "",
        pageSection: el ? el : "",
        planOption: "",
        productCategory: "",
        productName: "",
        question: "",
        searchTerm: "",
        videoTitle: "",
        bannerName: "",
        bannerType: "",
      };
      return obj;
    },

    // Text of a clicked element for analytics, without the visually-hidden
    // article title the "Read More" links now carry for screen readers
    // (mediacenter.html, WCAG 2.5.3) — keeps buttonName "Read More" as before.
    visibleText: function (el) {
      if (!el) {
        return "";
      }
      const clone = el.cloneNode(true);
      $(clone).find(".visually-hidden").remove();
      return clone.textContent.replace(/\s+/g, " ").trim();
    },

    init: function () {
      this.sortYear();
      this.showBlogsAtInitial();
      this.searchOnInput();
      this.searchByYear();
      this.formSubmit();

      $(".news .tab__pane--content_text").on(
        "click",
        function (e) {
          let pageSection = "News and Press Release_News";
          let buttonName = mediaCenterObject.methods.visibleText(e.target);
          let articleName=$(this).find('h3').text();
          let obj = mediaCenterObject.methods.dataLayerObj(
            pageSection,
            buttonName,
            articleName
          );
          createDataLayer("Download_NonProduct", obj);
        }
      );

      $(".pr .tab__pane--content_text").on(
        "click",
        function (e) {
          let pageSection = "News and Press Release_PressRelease";
          let buttonName = mediaCenterObject.methods.visibleText(
            e.currentTarget.getElementsByClassName("read_more_btn")[0]
          );
          let articleName=$(this).find('h3').text();
          let obj = mediaCenterObject.methods.dataLayerObj(
            pageSection,
            buttonName,
            articleName
          );
          createDataLayer("Download_NonProduct", obj);
        }
      );

      $(".media_center_blogs .view-all").on('click', function(e){
            let pageSection = "News and Press Release";
            let buttonName = e.currentTarget.innerText.replace(/\n/g, "").trim();
            let obj = mediaCenterObject.methods.dataLayerObj(pageSection, buttonName);
            createDataLayer("buttonClick", obj);
      })
    },
  },
};

if ($(".media_center").length > 0) {
  mediaCenterObject.methods.init();
  mediaCenterObject.methods.buttonClickHandler();
}
